import { States } from '../../../../../../constants';

export const validStateOptions: string[] = [];
States.forEach((state) => {
  validStateOptions.push(state.name);
});

export const rangeOneToFive = ['1', '2', '3', '4', '5'];

export const initialValues: { [key: string]: { [key: string]: any } } = {
  propertyName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  streetAddress: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  city: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  state: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  zipCode: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      maxLength: 5,
    },
  },
  currentUse: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  futureUse: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  codeViolation: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  propertyTaxes: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  waterBills: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  sewageBills: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  refuseBills: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
};

export const potentialProperty = ['Government owned', 'Privately owned', 'Delinquent'];
export const municipalities = [
  { name: 'Avalon' },
  { name: 'Bellevue' },
  { name: 'Blawnox' },
  { name: 'Braddock' },
  { name: 'Braddock Hills' },
  { name: 'Carnegie' },
  { name: 'Clairton' },
  { name: 'Coraopolis' },
  { name: 'East Pittsburgh' },
  { name: 'Elizabeth Borough' },
  { name: 'Forward' },
  { name: 'Glassport' },
  { name: 'Homestead' },
  { name: 'McKees Rocks' },
  { name: 'Millvale' },
  { name: 'Mount Oliver,' },
  { name: 'North Braddock' },
  { name: 'Pitcairn' },
  { name: 'Rankin' },
  { name: 'Sharpsburg' },
  { name: 'Stowe' },
  { name: 'Swissvale' },
  { name: 'Tarentum' },
  { name: 'Turtle Creek' },
  { name: 'Verona' },
  { name: 'Versailles' },
  { name: 'Wall' },
  { name: 'Whitaker' },
  { name: 'Whitaker and Wilmerding' },
];

export const race = [
  'Black or African American',
  'White',
  'American Indian and Alaska Native',
  'Asian',
  'Native Hawaiian and Other Pacific Islander',
  'Two or more races',
];

export const clientType = ['Resident Investor', 'Community Developers', 'CDCs'];
